{
  "ddd, MMM D, YYYY": "YYYY年M月D日(ddd)",
  "h:mm A z": "H:mm z",
  "Video fragment {number}": "動画パート{number}",
  "Upload to Beginning": "先頭にアップロード",
  "Upload to End": "末尾にアップロード",
  "Replace All Video": "動画全体を置き換え",
  "Total length: {duration}": "合計時間：{duration}",
  "Upload After": "この後にアップロード",
  "Delete this uploaded video?": "このアップロード済みの動画を削除しますか？",
  "Delete this video fragment?": "この動画パートを削除しますか？",
  "Video fragment deleted": "動画パートを削除しました",
  "Could not delete video fragment": "動画パートを削除できませんでした",
  "Loading event video...": "イベントの動画を読み込み中...",
  "Deleting video fragment...": "動画パートを削除中...",
  "Loading uploaded video fragments...": "アップロードした動画パートを読み込み中...",
  "Could not finish upload": "アップロードを完了できませんでした",
  "Could not queue video conversion": "動画の変換を予約できませんでした",
  "Event video is uploaded and will be processed now": "イベントの動画がアップロードされました。これから処理されます",
  "Upload an edited or backup recording of the live stream. This will replace the current video on event page.": "ライブ配信の編集済み録画やバックアップ録画をアップロードします。イベントページの現在の動画は置き換えられます。",
  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically": "イベントページに動画をアップロードします。動画はライブ配信が始まるまでイベントページに表示されます。ライブ配信を開始すると、アップロードした動画は自動的にライブ配信に置き換わります",
  "Delete Uploaded Video?": "アップロードした動画を削除しますか？",
  "Notify all guests when it's uploaded": "アップロード完了時にすべてのゲストに通知",
  "Permission to Access Photo Library Necessary": "写真へのアクセス許可が必要です",
  "Could not access selected video.": "選択した動画にアクセスできませんでした。",
  "Could not open the video.": "動画を開けませんでした。",
  "This video may still be in iCloud. Open Photos, download it to this iPhone, and try again.": "この動画はまだiCloudにある可能性があります。「写真」アプリを開いてこのiPhoneにダウンロードしてから、もう一度お試しください。",
  "Please try again, or choose another video.": "もう一度お試しいただくか、別の動画を選んでください。",
  "Could not open video library.": "動画ライブラリを開けませんでした。",
  "Please check if permissions are given": "アクセスが許可されているか確認してください",
  "Could not start video upload.": "動画のアップロードを開始できませんでした。",
  "Please try another video or check photo permissions in iOS Settings.": "別の動画を試すか、iOSの「設定」で写真へのアクセス許可を確認してください。",
  "Only mov or mp4 files are accepted": "アップロードできるのはmovまたはmp4ファイルのみです",
  "Cancel this upload?": "このアップロードをキャンセルしますか？",
  "The part already uploaded will be discarded.": "すでにアップロードされた部分は破棄されます。",
  "Cancel upload": "アップロードをキャンセル",
  "Keep uploading": "アップロードを続ける",
  "{loaded} from {total}": "{loaded} / {total}",
  "Uploading...": "アップロード中...",
  "Video Uploaded": "動画をアップロードしました",
  "Converting Video. This may take a few minutes.": "動画を変換しています。数分かかる場合があります。",
  "Replace live video": "ライブ配信の動画を置き換え",
  "MOV or MP4 video. 10GB Max.": "MOVまたはMP4の動画。最大10GB。",
  "Failed to start upload": "アップロードを開始できませんでした",
  "Trim the video": "動画をトリミング",
  "trim|From": "開始位置",
  "Enter start time in hh:mm:ss format if you want to clip the beginning of the video. For example, if you want to start the video 20 minutes into the live stream, enter \"00:20:00\"": "動画の冒頭をカットしたい場合は、開始時間をhh:mm:ss形式で入力してください。たとえば、ライブ配信の20分後から動画を始めたい場合は「00:20:00」と入力します",
  "MOV or MP4 video. Up to 200 GB.": "MOVまたはMP4の動画。最大200GB。",
  "upload status|converted": "変換済み",
  "upload status|converting": "変換中",
  "upload status|waiting to convert": "変換待ち",
  "This video was already uploaded for this event (status: {status}).": "この動画はすでにこのイベントにアップロードされています（ステータス：{status}）。",
  "{part} of {total} {unit}": "{part} / {total} {unit}",
  "Resuming — {sizes} were already uploaded": "再開しています — {sizes}はアップロード済みです",
  "Starting over — nothing had finished uploading yet": "最初からやり直しています — まだアップロードが完了した部分はありません",
  "under a minute left": "残り1分未満",
  "about {count} min left": {
    "other": "残り約{count}分"
  },
  "about {count} h {minutes} min left": {
    "other": "残り約{count}時間{minutes}分"
  },
  "about {count} h left": {
    "other": "残り約{count}時間"
  },
  "Pause": "一時停止",
  "Resume": "再開",
  "Upload again": "もう一度アップロード",
  "upload card|View event page": "イベントページを見る",
  "You can leave this page meanwhile.": "その間、このページを離れても大丈夫です。",
  "Processing starting soon": "まもなく処理を開始します",
  "We're finishing other videos first. You can leave this page meanwhile.": "ほかの動画の処理を先に進めています。その間、このページを離れても大丈夫です。",
  "Waiting for processing…": "処理を待っています…",
  "Preparing your video…": "動画を準備中…",
  "Publishing to your event page…": "イベントページに公開中…",
  "Almost done.": "もうすぐ完了します。",
  "Still processing…": "まだ処理中です…",
  "Processing video… {percent}%": "動画を処理中…{percent}%",
  "Uploading video": "動画をアップロード中",
  "Waiting for network…": "ネットワークを待っています…",
  "Starting the upload…": "アップロードを開始しています…",
  "Calculating time left…": "残り時間を計算中…",
  "Paused": "一時停止中",
  "The upload continues where it stopped.": "アップロードは中断したところから再開されます。",
  "Finishing upload…": "アップロードを完了しています…",
  "Putting the video together.": "動画を結合しています。",
  "{size} uploaded": "{size}アップロード済み",
  "Your video is ready": "動画の準備ができました",
  "It's on your event page now.": "イベントページに公開されました。",
  "Upload interrupted": "アップロードが中断されました",
  "Already uploaded": "アップロード済み",
  "Upload cancelled": "アップロードをキャンセルしました",
  "This upload was cancelled. The event's video hasn't changed.": "このアップロードはキャンセルされました。イベントの動画は変更されていません。",
  "Could not open the video. Please try again.": "動画を開けませんでした。もう一度お試しください。",
  "Discard this unfinished upload?": "未完了のアップロードを破棄しますか？",
  "The part already uploaded will be deleted.": "すでにアップロードされた部分は削除されます。",
  "Discard upload": "アップロードを破棄",
  "upload|Keep it": "残す",
  "It replaces the event's video.": "イベントの動画を置き換えます。",
  "It goes at the end of the event's video.": "イベントの動画の最後に追加されます。",
  "It goes at the beginning of the event's video.": "イベントの動画の最初に追加されます。",
  "It goes between the event's video fragments.": "イベントの動画パートの間に追加されます。",
  "Try again, or upload it again.": "もう一度試すか、アップロードし直してください。",
  "Please upload it again.": "もう一度アップロードしてください。",
  "We couldn't process your video": "動画を処理できませんでした",
  "“{filename}” was uploaded but couldn't be converted.": "「{filename}」はアップロードされましたが、変換できませんでした。",
  "The video was uploaded but couldn't be converted.": "動画はアップロードされましたが、変換できませんでした。",
  "If it keeps happening, contact support.": "繰り返し発生する場合は、サポートにお問い合わせください。",
  "Trying again…": "再試行中…",
  "Try again →": "もう一度試す →",
  "Contact support →": "サポートに問い合わせる →",
  "notice|Dismiss": "閉じる",
  "Unfinished upload": "未完了のアップロード",
  "“{filename}” ({size}), {percent}% uploaded.": "「{filename}」（{size}）、{percent}%アップロード済み。",
  "Choose the same file to continue where the upload stopped.": "同じファイルを選ぶと、中断したところからアップロードを再開できます。",
  "Resume upload →": "アップロードを再開 →",
  "Discard": "破棄",
  "Photo Library": "フォトライブラリ",
  "Files": "ファイル",
  "Choose a video": "動画を選択",
  "Your event is live. Upload after the stream ends.": "イベントはライブ配信中です。配信が終わってからアップロードしてください。",
  "This event no longer exists.": "このイベントはもう存在しません。",
  "You don't have access to upload video to this event.": "このイベントに動画をアップロードする権限がありません。",
  "This upload has expired. Please choose the file again.": "このアップロードは有効期限が切れています。もう一度ファイルを選んでください。",
  "This upload has already finished or was cancelled.": "このアップロードはすでに完了したか、キャンセルされています。",
  "Some parts of the video haven't uploaded yet.": "動画の一部がまだアップロードされていません。",
  "The uploaded video doesn't match the file. Please upload it again.": "アップロードされた動画がファイルと一致しません。もう一度アップロードしてください。",
  "This video was already uploaded for this event.": "この動画はすでにこのイベントにアップロードされています。",
  "Too many uploads are in progress. Finish or cancel one, then try again.": "進行中のアップロードが多すぎます。いずれかを完了するかキャンセルしてから、もう一度お試しください。",
  "This file is too large. Videos can be up to 200 GB.": "ファイルが大きすぎます。動画は200GBまでです。",
  "This file is empty. Please choose another video.": "このファイルは空です。別の動画を選んでください。",
  "Please choose a video file (MP4 or MOV).": "動画ファイル（MP4またはMOV）を選んでください。",
  "This upload couldn't be started. Please choose the file again.": "このアップロードを開始できませんでした。もう一度ファイルを選んでください。",
  "Video upload is temporarily unavailable. Please try again later.": "動画のアップロードは一時的にご利用いただけません。しばらくしてからもう一度お試しください。",
  "Something went wrong on our side. Please try again.": "当社側で問題が発生しました。もう一度お試しください。",
  "This video can't be converted again. Please upload it again.": "この動画は再変換できません。もう一度アップロードしてください。",
  "This upload is no longer available. Please choose the file again.": "このアップロードはもう利用できません。もう一度ファイルを選んでください。",
  "This upload can't continue. Please choose the file again.": "このアップロードは続行できません。もう一度ファイルを選んでください。",
  "This file can't be uploaded. Please choose another video.": "このファイルはアップロードできません。別の動画を選んでください。",
  "Too many uploads at once. Please wait a moment and try again.": "同時に行われているアップロードが多すぎます。しばらく待ってから、もう一度お試しください。",
  "Could not reach the upload service. Check your internet connection and try again.": "アップロードサービスに接続できませんでした。インターネット接続を確認して、もう一度お試しください。",
  "The upload was interrupted. Check your internet connection and try again.": "アップロードが中断されました。インターネット接続を確認して、もう一度お試しください。",
  "This upload doesn't match the file. Please choose the file again.": "このアップロードはファイルと一致しません。もう一度ファイルを選んでください。",
  "Could not finish the upload. Please try again.": "アップロードを完了できませんでした。もう一度お試しください。",
  "Could not read the video file. Please choose it again.": "動画ファイルを読み込めませんでした。もう一度選んでください。",
  "Another upload for this event is still in progress.": "このイベントでは、別のアップロードがまだ進行中です。",
  "There's no upload to continue.": "再開できるアップロードはありません。",
  "Could not start the conversion again. Please try again later.": "変換を再開できませんでした。しばらくしてからもう一度お試しください。",
  "Choose the file again to continue the upload.": "アップロードを続けるには、もう一度ファイルを選んでください。",
  "That's a different file. Choose “{name}” to continue this upload.": "別のファイルです。このアップロードを続けるには「{name}」を選んでください。",
  "Choose a video file.": "動画ファイルを選んでください。",
  "There isn't enough free space on this device to continue the upload. Free up some space, then try again.": "このデバイスの空き容量が不足しているため、アップロードを続けられません。空き容量を増やしてから、もう一度お試しください。",
  "This upload was cancelled.": "このアップロードはキャンセルされました。",
  "Upload failed": "アップロードに失敗しました",
  "Upload File": "ファイルをアップロード",
  "File uploaded": "ファイルをアップロードしました",
  "Guest list saved to Files": "ゲストリストを「ファイル」に保存しました",
  "Downloads > {filename}": "ダウンロード > {filename}",
  "Files > On my iPhone > EventLive > {filename}": "ファイル > このiPhone内 > EventLive > {filename}",
  "Could not save the file.": "ファイルを保存できませんでした。",
  "Please try again on web": "ウェブ版でもう一度お試しください"
}
